const BonaireSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110930)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.85824 5.8572C1.57191 10.1435 -0.361447 15.8915 0.0567557 21.4967L21.4976 0.0557982C15.8925 -0.362483 10.1446 1.57088 5.85824 5.8572Z"
        fill="#FFDA44"
      />
      <path
        d="M7.14111 35.3182C14.999 41.9293 26.7458 41.5383 34.1419 34.1423C41.538 26.7463 41.929 14.9994 35.3178 7.1416L7.14111 35.3182Z"
        fill="#0052B4"
      />
      <path
        d="M19.9288 19.1953L21.6523 18.2617L19.9288 17.3281C19.5263 14.7139 17.4609 12.6484 14.8467 12.2461L13.913 10.5225L12.9795 12.246C10.3654 12.6483 8.29992 14.7139 7.89742 17.328L6.17383 18.2617L7.89734 19.1953C8.29977 21.8094 10.3652 23.875 12.9794 24.2773L13.913 26.0009L14.8466 24.2774C17.4609 23.875 19.5263 21.8094 19.9288 19.1953ZM13.9131 21.74C11.9921 21.74 10.4348 20.1828 10.4348 18.2617C10.4348 16.3406 11.992 14.7834 13.9131 14.7834C15.8342 14.7834 17.3914 16.3406 17.3914 18.2617C17.3914 20.1828 15.8341 21.74 13.9131 21.74Z"
        fill="black"
      />
      <path
        d="M13.9129 15.6514L14.666 16.9557H16.1722L15.419 18.26L16.1722 19.5644H14.666L13.9129 20.8687L13.1599 19.5644H11.6538L12.4069 18.26L11.6538 16.9557H13.1599L13.9129 15.6514Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110930">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BonaireSvg;
